var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVectorTop = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 131,
    viewBox: "0 0 331 131",
    width: 331,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m308.695-125.131c-46.127-63.489-143.624-63.516-222.3249-6.336-78.70093 57.1793-113.1166 164.4404-62.676 213.4017s142.4319 77.3033 222.3249 6.3365c79.894-70.9672 108.804-149.9124 62.676-213.4022z",
    fill: "#2e933c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m308.695-125.131c-46.127-63.489-143.624-63.516-222.3249-6.336-78.70093 57.1793-113.1166 164.4404-62.676 213.4017s142.4319 77.3033 222.3249 6.3365c79.894-70.9672 108.804-149.9124 62.676-213.4022z",
    fill: "#000",
    fillOpacity: 0.2
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVectorTop);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/vectorTop.26cc1694517e06c4c14c054c3796aa68.svg";